export default __webpack_public_path__ + "static/media/sad-face.1e97d465.gif";